const PlaygroundAuthType = {
  NONE: "NONE",
  BEARER_TOKEN: "BEARER_TOKEN",
  URL_PARAM: "URL_PARAM",
  OAUTH: "OAUTH",
};

export default PlaygroundAuthType;
